// Scoped initializer for video controls
export function initVideo(root = document) {
  const scope = root && root.querySelectorAll ? root : document;

  // Find all play/pause buttons within the root
  const playPauseButtons = scope.querySelectorAll('.uom-c-video__button');

  if (!playPauseButtons || playPauseButtons.length === 0) {
    // No buttons to initialise in this root
    return;
  }

  // Initialize each video player inside the provided root
  playPauseButtons.forEach(function (playPauseButton) {
    // Get the video element by finding the closest uom-c-video container and then getting the video child
    const videoContainer = playPauseButton.closest('.uom-c-video');
    if (!videoContainer) return;
    const videoElement = videoContainer.querySelector('video');

    if (!videoElement) {
      return;
    }

    // Avoid registering duplicate listeners
    if (playPauseButton.__uom_video_inited) return;
    playPauseButton.__uom_video_inited = true;

    // Add click event listener for play/pause functionality
    playPauseButton.addEventListener('click', function () {
      try {
        if (videoElement.paused) {
          videoElement.play();

          playPauseButton.innerHTML = `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path d="M10 4H6V20H10V4Z" fill="currentColor" />
            <path d="M18 4H14V20H18V4Z" fill="currentColor" />
          </svg>`;

          playPauseButton.setAttribute('aria-label', 'Pause video');
          playPauseButton.setAttribute('title', 'Pause video');
          playPauseButton.setAttribute('data-state', 'playing');
        } else {
          videoElement.pause();

          playPauseButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 2V22L21 12L3 2Z" fill="currentColor"/>
          </svg>`;

          playPauseButton.setAttribute('aria-label', 'Play video');
          playPauseButton.setAttribute('title', 'Play video');
          playPauseButton.setAttribute('data-state', 'paused');
        }
      } catch (error) {
        console.error('Error controlling video playback:', error);
      }
    });
  });
}

// Auto-init for normal pages
document.addEventListener('DOMContentLoaded', function () {
  initVideo(document);
});
